export const generateDeviceLastReading = (time: number) => {
    return {
        time,
        tank: 0,
        battery: null,
        temperature: null,
        voltage: null,
        insert_time: null,
        battery_warn: null,
        battery_crit: null,
        rssi: 0,
        chn: 0,
        rsrp: null,
        rsrq: null,
        band: 0,
    };
};
